import React from "react";

function BusinessCapital({ inHand, payToMarket }) {
  return (
    <div className="container-fluid ps-4 pe-4">
      <div className="row">
        <div className="col-12 bgCustomBusiness py-3 mt-4">
          <i className="fa-solid fa-coins" /> Business Capital
        </div>
        <div className="col-12 bgCustomBusinessMain py-3">
          <div className="row">
            {/* In Hand */}
            <div className="col-12 col-md-6 mt-4">
              <div className="btncapital">
                <i className="fa-solid fa-handshake me-2" /> In Hand
              </div>
              <div className="goldHand py-3 mt-4">
                <div className="text">
                  <i
                    className="fa-solid fa-layer-group me-2"
                    style={{ color: "#d4af37" }}
                  />
                  Gold
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="handGold"
                    className="inputBusiness"
                    value={inHand.gold}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="goldSilver py-3 mt-4">
                <div className="text">
                  <i
                    className="fa-solid fa-square me-2"
                    style={{ color: "#b0b0b0" }}
                  />
                  Silver
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="handSilver"
                    className="inputBusiness"
                    value={inHand.silver}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="goldCash py-3 mt-4">
                <div className="text">
                  <i className="fa-solid fa-sack-dollar text-success me-2" />
                  Cash
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="handCash"
                    className="inputBusiness"
                    value={inHand.cash}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            {/* Pay To Market */}
            <div className="col-12 col-md-6 mt-4">
              <div className="btncapital">
                <i className="fa-solid fa-chart-line me-2" /> Pay To Market
              </div>
              <div className="goldHand py-3 mt-4">
                <div className="text">
                  <i
                    className="fa-solid fa-layer-group me-2"
                    style={{ color: "#d4af37" }}
                  />
                  Gold
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="payMarketGold"
                    className="inputBusiness"
                    value={payToMarket.gold}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="goldSilver py-3 mt-4">
                <div className="text">
                  <i
                    className="fa-solid fa-square me-2"
                    style={{ color: "#b0b0b0" }}
                  />
                  Silver
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="payMarketSilver"
                    className="inputBusiness"
                    value={payToMarket.silver}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="goldCash py-3 mt-4">
                <div className="text">
                  <i className="fa-solid fa-sack-dollar text-success me-2" />
                  Cash
                </div>
                <div className="text">
                  <input
                    type="text"
                    id="MarketTotalCash"
                    className="inputBusiness"
                    value={payToMarket.cash}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessCapital;
